import { assign } from 'xstate5';

import { type CustomizationMachineAction } from '../../types';

// ─────────────────────────────────────────────────────────────────────────────

export const storePendingAddToBag: CustomizationMachineAction = assign({
  shouldAddToBagWhenReady: true,
});
